import React from 'react';
import c from 'classnames';
import s from './DotIndicator.scss';
const DotIndicator = ({ className  })=>{
    return /*#__PURE__*/ React.createElement("div", {
        className: c(s['root'], className)
    });
};
DotIndicator.displayName = 'DotIndicator';
export default DotIndicator;
